import React, { HTMLAttributes } from 'react';
import Immutable from 'immutable';
import {
  Container,
  WysiwygField,
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';


import './style.scss';
import { ParagraphUSP as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphUSPProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphUSP: React.FC<ParagraphUSPProps> = ({
  entity,
}) => {
  const paragraphUSP = entity.toJS();
  const uuid = paragraphUSP.uuid[0].value;
  const title = paragraphUSP.field_title[0]?.value;
  const body = paragraphUSP.field_body[0].processed;
  const paragraphs = paragraphUSP.field_paragraphs;
  const linkTitle = paragraphUSP.field_link[0]?.title;
  const linkUri = paragraphUSP.field_link[0]?.alias || paragraphUSP.field_link[0]?.uri;

  return (
    <div id={uuid} className="ParagraphUSP">
      <Container>
        <h2>{title}</h2>
        <WysiwygField html={body} />

        {paragraphs.length > 0 ? (
          <div className="ParagraphUSP__subparagraphs">
            {paragraphs.map((paragraph) => {
              const id = paragraph.target_id;

              return (
                <Paragraph
                  key={`paragraph:${id}`}
                  id={id}
                  entity={Immutable.fromJS(paragraph.entity)}
                />
              );
            })}
          </div>
        ) : null}

        {linkUri ? (
          <Button href={linkUri}>
            {linkTitle}
          </Button>
        ) : null}
      </Container>
    </div>
  );
};

export default ParagraphUSP;
